import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import TwoFaAuth from '~/pages/Authentication/TwoFaAuth';
import { RouteTypes } from '../constants';
import { useAuth } from './AuthProvider';

const PrivateRoute: React.FunctionComponent = () => {
  const { hasToken, isTfaRequired, isAuthenticated } = useAuth();
  const systemDataContext = useContext(ThemeContext)

  if (isTfaRequired) {
    return <TwoFaAuth />
  }

  if (!hasToken && !localStorage.getItem('theme') && systemDataContext?.cover) {
    localStorage.setItem('theme', JSON.stringify(systemDataContext))
  }

  /* if(hasToken && systemData?.hideMenuAndHeader && systemData?.logged?.roleSlug) {
    return <ClimateCheck/>
  } */

  return isAuthenticated ? <Outlet /> : <Navigate to={RouteTypes.LOGIN} />;
};

export default PrivateRoute;
